// extracted by mini-css-extract-plugin
module.exports = {"list":"styles_list__1P8Ir","paginationWrapper":"styles_paginationWrapper__2CDME"};